import { render, staticRenderFns } from "./ExamDetail.vue?vue&type=template&id=1ac86a53&scoped=true&"
import script from "./ExamDetail.vue?vue&type=script&lang=js&"
export * from "./ExamDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExamDetail.vue?vue&type=style&index=0&id=1ac86a53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac86a53",
  null
  
)

component.options.__file = "ExamDetail.vue"
export default component.exports